import ReactGA from 'react-ga4';
import {appConfig} from '~/config';

export const initGA = () => {
  if (appConfig.googleAnalytics.isEnable) {
    ReactGA.initialize([
      {
        trackingId: appConfig.googleAnalytics.elevateMeasurementId,
      },
      {
        trackingId: appConfig.googleAnalytics.measurementId,
      },
    ]);
  }
};
